import { STUDIO_API_BASE_URL_V5 } from '../config';

export const ReleasesAPIRoutes = {
  getReleases: () => `${STUDIO_API_BASE_URL_V5}/releases`,
  readRelease: () => `${STUDIO_API_BASE_URL_V5}/read_receipt`,
};
